const initialState = {
    accountBeingUpdated: null
}

export default initialState;
